import React, { useState, useEffect } from 'react';
import './EditGroupModal.css';

function EditGroupModal({ isOpen, onClose, group, onUpdateGroup }) {
  const [name, setName] = useState('');
  const [context, setContext] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  // Populate form when group changes
  useEffect(() => {
    if (group) {
      setName(group.name || '');
      setContext(group.context || '');
    }
  }, [group]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      setError('Group name is required');
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      await onUpdateGroup(group.id, {
        name: name.trim(),
        context: context.trim() || null
      });
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to update group');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setError('');
    onClose();
  };

  if (!isOpen || !group) return null;

  return (
    <div className="edit-group-overlay" onClick={handleClose}>
      <div className="edit-group-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Edit Group</h2>

        <form onSubmit={handleSubmit}>
          <div className="edit-group-field">
            <label htmlFor="edit-group-name">Name</label>
            <input
              id="edit-group-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter group name..."
            />
          </div>

          <div className="edit-group-field">
            <label htmlFor="edit-group-context">Context <span className="edit-group-optional">(optional)</span></label>
            <textarea
              id="edit-group-context"
              value={context}
              onChange={(e) => setContext(e.target.value)}
              placeholder="Describe this group's purpose... e.g., 'Major donor prospects for our new building campaign' or 'Board members to cultivate for annual fund'"
              rows={4}
            />
          </div>

          {error && <div className="edit-group-error">{error}</div>}

          <div className="edit-group-actions">
            <button
              type="button"
              className="edit-group-cancel"
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="edit-group-submit"
              disabled={isSubmitting || !name.trim()}
            >
              {isSubmitting ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditGroupModal;
